var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsgActionPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.875 13.125L3.75 16.25",
    stroke: "#2A3842",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0561 2.32024L7.18887 7.18743C7.18887 7.18743 5.02481 6.10149 2.70449 7.97649C2.63622 8.03174 2.58035 8.10077 2.54054 8.17906C2.50073 8.25735 2.47787 8.34315 2.47345 8.43087C2.46903 8.51859 2.48314 8.60626 2.51488 8.68815C2.54661 8.77005 2.59525 8.84434 2.65762 8.90618L11.0795 17.3281C11.1425 17.3922 11.2187 17.442 11.3027 17.474C11.3868 17.506 11.4767 17.5195 11.5665 17.5136C11.6562 17.5077 11.7436 17.4824 11.8227 17.4396C11.9018 17.3968 11.9708 17.3374 12.0248 17.2656C12.6811 16.3984 13.7123 14.6015 12.8139 12.8124L17.6811 7.94524C17.7401 7.88709 17.787 7.81777 17.819 7.74132C17.851 7.66487 17.8675 7.58281 17.8675 7.49993C17.8675 7.41705 17.851 7.335 17.819 7.25855C17.787 7.1821 17.7401 7.11277 17.6811 7.05462L12.9467 2.32024C12.8885 2.26119 12.8192 2.21429 12.7428 2.18228C12.6663 2.15027 12.5843 2.13379 12.5014 2.13379C12.4185 2.13379 12.3364 2.15027 12.26 2.18228C12.1835 2.21429 12.1142 2.26119 12.0561 2.32024Z",
    stroke: "#2A3842",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgActionPin);
export default __webpack_public_path__ + "static/media/msg-action-pin.98ca9641bbf7fcf7f2fc05015024afe0.svg";
export { ForwardRef as ReactComponent };